// importing a component whih will show when there is delay in action
import Loader from "../Loader/Loader";
// importing all the values from contactAPI
import { useValue } from "../../context";
// Importing Style
import Style from './Home.module.css';
// Importing some dependiences from the react-router-dom
import { Link } from "react-router-dom";


// Home function
function Home() {
    // Importing all the dependencies from the ContactAPI(stateManagementLibrary)
    const {contactList, isLoading , deleteContact, searchTerm, setSearchTerm} = useValue();

    // Filter contacts based on search term (searches by name, email, or phone)
    const filteredContacts = contactList.filter((contact) => {
        const term = searchTerm.toLowerCase();
        return (
            contact.name.toLowerCase().includes(term) ||
            contact.email.toLowerCase().includes(term) ||
            contact.phone.toLowerCase().includes(term)
        );
    });

    if(isLoading){
        return <Loader />
    }
    // UI for the Home Page, in which all the contact is showing
    return (
        <>
            {/* Top bar with search and add button */}
            <div className={Style.topBar}>
                {/* Search input to filter contacts */}
                <div className={Style.searchContainer}>
                    <input
                        type="text"
                        placeholder="Search by name, email or phone..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={Style.searchInput}
                    />
                    {searchTerm && (
                        <button
                            className={Style.clearSearch}
                            onClick={() => setSearchTerm("")}
                        >
                            ✕
                        </button>
                    )}
                </div>
                {/* Button which will allow to Add the contact */}
                <Link to = 'add-contact'>
                    <button className={Style.addButton}>Add To Contact</button>
                </Link>
            </div>
            {/* UI for the contactTable */}
            <div className={Style.contactTable}>
                <table className="table">
                    <thead>
                        {/* Table */}
                        <tr className={Style.tableHead}>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <th>Email</th>
                            <th>Number</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {/* Table Body */}
                    <tbody>
                        {filteredContacts.length === 0 ? (
                            <tr>
                                <td colSpan="5" className={Style.noResults}>
                                    No contacts found matching "{searchTerm}"
                                </td>
                            </tr>
                        ) : (
                            filteredContacts.map((contact, index) => (
                                <tr key={contact.id}>
                                    <td>{index+1}</td>
                                    <td>{contact.name}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.phone}</td>
                                    <td>
                                        <Link to= {`edit-contact/${contact.id}`}>
                                            <button className={Style.editButton}>Edit</button>
                                        </Link>

                                        <button onClick={()=>deleteContact(contact.id)} className={Style.deleteButton}>
                                            Delete
                                        </button>

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

        </>
    ) 
}

export default Home;